export default __webpack_public_path__ + "static/media/logo_h_lukesoft.d2a539aa.png";